export const UPDATE_TRIP_INFO = 'UPDATE_TRIP_INFO'